import React from "react";
import { X, ShieldCheck } from "lucide-react";

export default function AboutModal({ onClose }) {
  return (
    <div
      data-testid="about-modal"
      className="fixed inset-0 z-[80] flex items-center justify-center"
      style={{ background: "rgba(0,0,0,0.35)" }}
    >
      <div className="w-[480px] bg-[#ECE9D8] shadow-[0_10px_30px_rgba(0,0,0,0.5)] overflow-hidden" style={{ border: "1px solid #003c9e" }}>
        <div className="xp-titlebar h-[28px] flex items-center justify-between px-2 text-white">
          <div className="flex items-center gap-2 text-[12px] font-bold" style={{ textShadow: "1px 1px 1px rgba(0,0,0,0.4)" }}>
            About LemonWire.exe
          </div>
          <button
            data-testid="about-close"
            onClick={onClose}
            className="w-[20px] h-[18px] rounded-sm bg-gradient-to-b from-[#F58D85] via-[#E81123] to-[#8B0A14] text-white flex items-center justify-center hover:brightness-110"
          >
            <X size={10} strokeWidth={4} />
          </button>
        </div>
        <div className="p-5 flex gap-4">
          <div
            className="w-[72px] h-[72px] rounded-full shrink-0"
            style={{
              background: "radial-gradient(circle at 30% 30%, #FFF59D 0%, #FFEB3B 40%, #F9A825 80%, #6D4C00 100%)",
              boxShadow: "inset -2px -4px 4px rgba(0,0,0,0.4), 0 0 0 3px #6D4C00, 0 0 0 5px #ECE9D8, 0 0 0 6px #6D4C00"
            }}
          />
          <div className="flex-1">
            <div className="text-[20px] font-bold" style={{ fontFamily: '"Pixelify Sans", Tahoma, sans-serif' }}>
              <span className="text-[#F9A825]">Lemon</span><span className="text-[#32CD32]">Wire</span>
            </div>
            <div className="text-[11px] text-[#555] mb-2">Professional v2.7.32 (Gold Edition)</div>

            <div className="text-[11px] text-[#222] leading-relaxed">
              LemonWire.exe is a peer-to-peer file-sharing client for the discerning audiophile
              who refuses to accept malware with their MP3s. Every file on the network is
              pre-scanned, bitrate-verified, and certified a <b>banger</b>.
            </div>

            <div className="mt-3 flex items-center gap-2 text-[11px] text-[#1f8020] font-bold">
              <ShieldCheck size={13} /> No malware. Just bangers.
            </div>

            <div className="mt-4 bevel-in bg-white p-2 text-[10px] font-mono text-[#333]">
              &copy; 2003-2026 LemonWire Labs Inc.<br />
              Do not fold, spindle, or burn to CD-RW.<br />
              Hosted conceptually at <span className="text-[#003c9e]">lemonwire.fm</span>
            </div>

            <div className="mt-3 flex justify-end">
              <button
                data-testid="about-ok"
                onClick={onClose}
                className="bevel-btn px-6 py-1 text-[12px] font-bold min-w-[80px]"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
